module.exports = __webpack_public_path__ + "static/media/laval_background.59a80bfc.png";